import { useRouteLoaderData } from "react-router-dom";

import { SortColumn, SortDirection } from "@/shared/domain/files/FileService";

export const useSortParamsLoaderData: () => {
  sortColumn: SortColumn;
  sortDirection: SortDirection;
} = () => {
  // typecasting is fine here since the loader function includes type validation logic
  const { sortColumn, sortDirection } = useRouteLoaderData(
    "datasetBrowser",
  ) as {
    sortColumn: SortColumn;
    sortDirection: SortDirection;
  };

  return {
    sortColumn,
    sortDirection,
  };
};
